<template>
  <div class="customerList">
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="customers"
        @select="selectTest">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editCustomer.open(0)">新建</el-button>
        <el-button type="danger" @click="deleteIds">批量删除</el-button>
        <el-button type="primary" @click="$refs.relationshipManage.open(0)">客户关系管理</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="客户编号">
            <el-input v-model.trim="filter.customerNo" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
          <vm-search label="外部编号">
            <el-input v-model.trim="filter.outerNo" clearable/>
          </vm-search>
          <vm-search label="公司代码">
            <el-input v-model.trim="filter.companyNo" clearable/>
          </vm-search>
          <vm-search label="是否终端客户">
            <el-select v-model="filter.isEndCustomer" clearable>
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" type="selection" width="40"/>
      <el-table-column align="center" prop="customerNo" label="客户编号" width="70px"/>
      <el-table-column align="center" prop="customerName" label="客户名称"/>
      <el-table-column align="center" prop="districtName" label="所属区域" width="75px"/>
      <el-table-column align="center" prop="outerNo" label="外部编号" width="75px"/>
      <el-table-column align="center" prop="companyNo" label="公司代码" width="75px"/>
      <el-table-column align="center" prop="systemId" label="系统" width="70px">
        <template slot-scope="scope">
          <span>{{constant.systemIds[scope.row.systemId]}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="employeeNames" label="所属销售员" width="85px"/>
      <el-table-column align="center" prop="telephone" label="电话" width="110px"/>
      <!-- <el-table-column align="center" prop="greenChannel" label="发货快线" width="70px">
       <template slot-scope="scope">
         <el-tag>
           {{scope.row.greenChannel === true ? "是":"否"}}
         </el-tag>
       </template>
      </el-table-column> -->
      <el-table-column align="center" prop="isEndCustomer" label="是否终端客户" width="70px">
        <template slot-scope="scope">
          <el-tag>
            {{scope.row.isEndCustomer === true ? "是":"否"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="isRobot" label="是否机器人客户" width="70px">
        <template slot-scope="scope">
          <el-tag>
            {{scope.row.isRobot === true ? "是":"否"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="customerTypeName" label="客户类型" width="70px"/>
      <el-table-column align="center" prop="address" label="地址"/>
      <el-table-column label="操作" align="center" class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button v-if="addressAuth" type="primary" @click="$refs.AddCustomer.open(scope.row.customerID)">地址维护</el-button>
          <el-button v-if="editAuth" type="primary" @click="$refs.editCustomer.open(scope.row.customerID)">编辑</el-button>
          <el-button v-if="fileDeliveryAuth" type="primary" @click="$refs.fileDeliveryCustomer.open(scope.row.customerID)">随货附件</el-button>
          <el-button v-if="creditLimitAuth" type="primary" @click="$refs.creditLimitCustomer.open(scope.row.outerNo)">客户信贷</el-button>
          <el-button v-if="delAuth" type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <customer-address ref="AddCustomer" @save-success="getList(1)"/>
    <customer-edit ref="editCustomer" @save-success="getList(1)"/>
    <customer-delivery-file ref="fileDeliveryCustomer" @save-success="getList(1)"/>
    <relationship-manage ref="relationshipManage" @save-success="getList(1)"/>
    <customer-credit-limit ref="creditLimitCustomer" @save-success="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import CustomerEdit from "@/views/information/Customer/CustomerEdit";
  import RelationshipManage from "@/views/information/Customer/RelationshipManage";
  import CustomerAddress from "@/views/information/Customer/CustomerAddress";
  import CustomerDeliveryFile from "@/views/information/Customer/CustomerDeliveryFile";
  import CustomerCreditLimit from "@/views/information/Customer/CustomerCreditLimit";

  export default {
    name: "Customer",
    components: {CustomerDeliveryFile, CustomerAddress, RelationshipManage, CustomerEdit, VmTable, VmSearch, CustomerCreditLimit},
    data() {
      return {
        constant,
        editAuth: this.$auth(14),
        delAuth: this.$auth(15),
        addressAuth: this.$auth(722),
        fileDeliveryAuth: this.$auth(723),
        creditLimitAuth: this.$auth(724),
        idList: "",
        filter: {
          customerNo: "",
          customerName: "",
          outerNo: "",
          companyNo: "",
          isEndCustomer: "",
          excludedIds: [],
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      RelationshipManage() {
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.customerID);
          }
          //console.log(ids);
          this.$http
            .delete("basic","customers/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","customers",row.customerID).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss">
  /*@media only screen and (min-width: 1600px){*/
  /*.customerList{*/
  /*   table tr td {*/
  /*     font-size: 14px;*/
  /*   }*/
  /*}*/
  /*}*/

</style>
